import { GameVars } from "./GameVars";
import { GameManager } from "./GameManager";

// audiosprite --e "mp3,ogg" --o ../assets/audio/audiosprite *.mp3

export class AudioManager {

    private static lastEffectPlayed: string;
    private static loopID: number; 
    private static loopKey: string;
    private static timeLastEffectPlayed: number;
    private static loops: any [];

    public static init(): void {

        AudioManager.lastEffectPlayed = null;
        AudioManager.loopID = null;
        AudioManager.loopKey = null;
        AudioManager.loops = [];

        GameVars.currentScene.sound.mute = GameVars.gameData.muted;
    }

    public static toggleAudioState(): void {

        GameVars.gameData.muted = !GameVars.gameData.muted;
        GameManager.writeGameData();
        
        GameVars.currentScene.sound.mute = GameVars.gameData.muted;
    }

    public static playSound(key: string, loop?: boolean, volume?: number): number {

        loop = loop || false;
        volume = volume || 1;

        const t = new Date().getTime();

        if (t - AudioManager.timeLastEffectPlayed < 100 && AudioManager.lastEffectPlayed === key) {
            return;
        }

        if (loop && AudioManager.loopKey === key) {
            return;
        }

        AudioManager.timeLastEffectPlayed = t;
        AudioManager.lastEffectPlayed = key;

        if (loop) {
            AudioManager.loops[key] = GameVars.currentScene.sound.addAudioSprite("audiosprite");
            AudioManager.loops[key].play(key, { loop: true , volume: volume });
        } else {
            GameVars.currentScene.sound.playAudioSprite("audiosprite", key);
        }
    }

    public static stopSound(key: string): void {

       if (AudioManager.loops[key]) {
            AudioManager.loops[key].stop();
            AudioManager.loops[key] = null;
       }
    }

    public static onBlur(): void {
        
        // if (!GameVars.gameData.muted && AudioManager.howl) {
        //     AudioManager.howl.mute(true);
        // }
    }

    public static onFocus(): void {
        
        // if (!GameVars.gameData.muted && AudioManager.howl) {
        //     AudioManager.howl.mute(false);
        // }
    }
}
